import { render, staticRenderFns } from "./MonthlyDisbursement.vue?vue&type=template&id=7267b926&"
import script from "./MonthlyDisbursement.vue?vue&type=script&lang=ts&"
export * from "./MonthlyDisbursement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports